/** (Mirrors src/utils/keywordMatch.ts on the server.)
 *
 * Whole-word, case-insensitive keyword match for WHOIS exposure: "ian"
 * matches "Ian Smith" and "ian@example.com" but not "PrivacyGuardian" or
 * "Australian". A keyword counts as a word when the characters around it are
 * not letters or digits, so multi-word and punctuated keywords ("Paradise
 * Media", "ops@acme.com") still match as written.
 */
const cache = new Map<string, RegExp>();

export function keywordMatches(text: unknown, keyword: unknown): boolean {
  if (typeof text !== 'string' || typeof keyword !== 'string' || !text || !keyword.trim()) return false;
  const k = keyword.trim().toLowerCase();
  let re = cache.get(k);
  if (!re) {
    const escaped = k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    re = new RegExp(`(?<![\\p{L}\\p{N}])${escaped}(?![\\p{L}\\p{N}])`, 'iu');
    if (cache.size > 500) cache.clear();
    cache.set(k, re);
  }
  return re.test(text);
}
